import type { SxProps } from '@mui/material';
import { Card, Container } from '@mui/material';
import type { FC, PropsWithChildren } from 'react';

export const CenterLayout: FC<PropsWithChildren> = ({ children }) => (
  <Container maxWidth="md" sx={{ px: 0 }}>
    {children}
  </Container>
);

export const PageCard: FC<PropsWithChildren<{ sx?: SxProps }>> = ({
  children,
  sx,
}) => (
  <Card elevation={4} sx={sx}>
    {children}
  </Card>
);

export const CenterCard: FC<PropsWithChildren<{ sx?: SxProps }>> = ({
  children,
  sx,
}) => (
  <CenterLayout>
    <PageCard sx={sx}>{children}</PageCard>
  </CenterLayout>
);
